import React from 'react';
const EmptyUserEventsIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#D9DBDF" />
    <path
      d="M18.8571 15.2188C18.8571 14.5458 19.4317 14 20.1429 14C20.854 14 21.4286 14.5458 21.4286 15.2188V16.4375H26.5714V15.2188C26.5714 14.5458 27.146 14 27.8571 14C28.5683 14 29.1429 14.5458 29.1429 15.2188V16.4375H31.0714C32.1362 16.4375 33 17.256 33 18.2656V20.0938H15V18.2656C15 17.256 15.8634 16.4375 16.9286 16.4375H18.8571V15.2188ZM33 31.6719C33 32.6812 32.1362 33.5 31.0714 33.5H16.9286C15.8634 33.5 15 32.6812 15 31.6719V21.3125H33V31.6719Z"
      fill="#8E949E"
    />
  </svg>
);

export default EmptyUserEventsIcon;
